import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Logout = ({ setLogout }) => {
  const navigate = useNavigate();
  const closeModal = () => {
    setLogout(false);
  };
  const handleLogout = () => {
    navigate("/logout");
  };
  return (
    <div className="ModalBox">
      <div
        id="NotificationAddModal"
        className="modal fade show"
        style={{ display: "block" }}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Category">
                <a className="CloseModal" onClick={closeModal}>
                  ×
                </a>
                <div className="LogOutArea">
                  <figure>
                    <img src={require("../assets/images/logout-modal.png")} />
                  </figure>
                  <h4>Logout</h4>
                  <p>Are you sure want to logout.</p>
                  <div className="LogOutButton">
                    <button className="Button Outline" onClick={closeModal}>
                      No
                    </button>
                    <button
                      className="Button Red"
                      id="Login"
                      onClick={handleLogout}
                    >
                      <a>Yes</a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;
